import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { range } from 'lodash';
import { List } from 'immutable';

class SportCompetitionsInput extends React.Component {
    static propTypes = {
        value: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.any,
                competitions: PropTypes.any
            })
        ),
        sports: ImmutablePropTypes.list,
        competitions: ImmutablePropTypes.map,
        collections: ImmutablePropTypes.map,
        disallowEmpty: PropTypes.bool,
        sortAlphabetically: PropTypes.bool,
        isLoading: PropTypes.bool,
        onChange: PropTypes.func,
        onQueryCompetitionsRequest: PropTypes.func.isRequired
    };

    static defaultProps = {
        sports: List(),
        value: [],
        sortAlphabetically: false,
        disallowEmpty: false
    };

    constructor(props, context) {
        super(props, context);

        this.state = this.getState(props);
    }

    getState(props) {
        return {
            value: props.value,
            activeSport: this.state && this.state.activeSport
        };
    }

    onChange(value) {
        if (this.props.onChange) {
            this.props.onChange(value || this.state.value);
        }
    }

    selectSport(sport) {
        return (e) => {
            e.preventDefault();

            const sportId = sport.get( 'id' );
            const { collections, onQueryCompetitionsRequest } = this.props;

            const alreadyFetchedSportCompetitions = collections.get( sportId );

            if ( sportId !== this.state.activeSport ) {
                this.setState( {
                    activeSport: sportId
                } );

                if ( !alreadyFetchedSportCompetitions ) {
                    onQueryCompetitionsRequest( sportId, {
                        sport: sportId
                    } );
                }
            }
        };
    }

    selectCompetition(competition) {
        return (e) => {
            e.preventDefault();

            this.updateSport(this.state.activeSport, competition.get('id'));
        };
    }

    toggleSport(sport) {
        return (e) => {
            e.preventDefault();

            let value = this.getSportValue(sport);

            this.updateSport(sport, value.competitions !== true);
        };
    }

    updateSport(sportId, comptitionId) {
        const { collections } = this.props;

        let { value } = this.state,
            c = this.getSportValue(sportId, true);

        let competitions = collections.getIn( [ sportId, 'items' ], List() ).toArray();

        if (!comptitionId) {
            value = value.filter(v => v.id !== sportId);
        } else if (comptitionId === true) {
            c.competitions = true;
        } else {
            if (c.competitions === true) {
                c.competitions = [].slice.call(competitions);
            }

            if (c.competitions.indexOf(comptitionId) !== -1) {
                c.competitions = c.competitions.filter(id => id !== comptitionId);
            } else {
                c.competitions.push(comptitionId);
            }
        }

        if (c.competitions.length === competitions.length) {
            c.competitions = true;
        }

        value = value.filter(v => v.competitions && v.competitions === true || v.competitions.length);

        this.setState({
            value
        });

        this.onChange(this.getValue(value));
    }

    getValue(value, props) {
        props = props || this.props;

        if (props.disallowEmpty) {
            value = JSON.parse(JSON.stringify(value || this.state.value));
            value.forEach(v => {
                if (v.competitions === true) {
                    v.competitions = this.props.competitions
                        .filter(cc => cc.getIn([ 'sport', 'id' ]) === v.id)
                        .map(cc => cc.get('id'))
                        .toArray();
                }
            });

            return value.filter(x => x.competitions.length);
        } else {
            return value;
        }
    }

    getSportValue(sportId, add) {
        let value = this.state.value.filter(c => c.id === sportId)[0];

        let shouldAdd = add && !value;

        if (!value) {
            value = { id: sportId, competitions: [] };
        }

        if (shouldAdd) {
            this.state.value.push(value);
        }

        return value;
    }

    sortAlphabetically(data) {
        const sorted = data.sort((prev, next) => {
            const prevName = prev.get('name').toLowerCase();
            const nextName = next.get('name').toLowerCase();

            if (prevName < nextName) return -1;
            else if (prevName > nextName) return 1;
            return 0;
        });

        return sorted;
    }

    render() {
        const { sports, sortAlphabetically, isLoading, collections, competitions } = this.props;
        const { activeSport } = this.state;

        let sValue = this.getSportValue(activeSport);

        const sportCompetitions = collections.getIn( [ activeSport, 'items' ], List() )
            .map( compId => competitions.get( compId ) );

        const isLoadinCompetitions = collections.getIn( [ activeSport, 'state' ] );

        let competitionsEl;
        if (activeSport) {
            let allClassName = sValue.competitions === true ? 'active all' : 'all';

            competitionsEl = (
                <ul data-test='competition-list'>
                    <li className={ allClassName }><a href="#" onClick={ this.toggleSport(activeSport) } data-test='all-competitions'>All</a></li>
                    {
                        (sortAlphabetically ? this.sortAlphabetically(sportCompetitions) : sportCompetitions).map(c => {
                            let props = {};

                            if (sValue.competitions === true || sValue.competitions.indexOf(c.get('id')) !== -1) {
                                props.className = 'active';
                            }

                            return (
                                <li key={ c.get('id') } { ...props }>
                                    <a href="#" onClick={ this.selectCompetition(c) } data-test-id={ c.get('id') }>{ c.get('name') }</a>
                                </li>
                            );
                        })
                    }
                </ul>
            );
        }

        return (
            <div className="row sport-competitions-input" data-test='sport-competitions-input'>
                {
                    isLoading ? <div className="col-12">
                        <div className="sport-competitions-input__info">
                            <span className="spinner spinner--inline"> </span>
                            Fetching sports & competitions...
                        </div>
                    </div> : void 0
                }
                <div className="col-6">
                    <ul data-test='sport-list'>
                        {
                            (sortAlphabetically ? this.sortAlphabetically(sports) : sports).map(sport => {
                                let s = this.getSportValue(sport.get('id')),
                                    props = {};

                                if (sport.get('id') === activeSport) {
                                    props.className = 'active';
                                }

                                let badge;
                                if (s.competitions === true) {
                                    badge = (<span className="sport-badge">All</span>);
                                } else if (s.competitions.length) {
                                    badge = (<span className="sport-badge">{ s.competitions.length }</span>);
                                }

                                return (
                                    <li key={ sport.get('id') } { ...props }>
                                        <a href="#" onClick={ this.selectSport(sport) } data-test='sport-name'>
                                            { sport.get('name') }
                                            { badge }
                                        </a>
                                    </li>
                                );
                            }).toArray()
                        }
                    </ul>
                </div>
                <div className="col-6">
                    { competitionsEl }
                    { isLoadinCompetitions === 'IN_PROGRESS' ? 'Please wait...' : void 0 }
                </div>
            </div>
        );
    }
}

export default SportCompetitionsInput;
